import { defineMessages } from '@transcend-io/internationalization';

export const notFoundMessages = defineMessages(
  'admin-dashboard.routes.NotFound.notFound',
  {
    alt: {
      defaultMessage:
        'you came to a page that does not exist and we are showing you a silly 404 message',
    },
    title: {
      defaultMessage: 'Page Not Found',
    },
  },
);
